export class EmailVerificationModel {
    email: string;
    isVerified: boolean;
}
